import React from 'react';
import { withRouter } from 'react-router-dom';
import { relatorioAction } from '../../store/relatorio';

//HELPERS
import * as c from '../../helpers/constants';
import { callApi } from '../../helpers/methods';
import { isBlank } from '../../helpers/stringHelper';

//EXPORT
import TableToExcel from 'react-html-table-to-excel';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { Row, Column, IBox, Title, Content, Button, Icon, Select } from '../inspinia';
import Pagination from "react-js-pagination";
import TableDetalheContatoToi from './tableDetalheContatoToi'
import TableNaoRecebidosToi from './tableResumoNaoRecebidosToi';
import TableEnvioLeituraToi from './tableResumoEnvioLeituraToi';
import TableVolumetriaToi from './tableVolumetriaToi';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TableDetalheContatoSmsToi from './tableDetalheContatoSmsToi';
import TableDetalheContatoWhatsappToi from './tableDetalheContatoWhatsappToi';
import TableDetalheContatoUnificadoToi from './tableDetalheContatoUnificadoToi';
import TableContabilizacaoToi from './tableContabilizacaoToi';
import TableFaturamentoToi from './TableFaturamentoToi';

//MASK
import InputMask from 'react-input-mask';
import TableDetalheAgendamentoToi from './tableDetalheAgendamentoToi';
import TableDetalhadoSimplificadoToi from './tableDetalhadoSimplificadoToi';
import TableVolumetriaUsuario from './tableVolumetriaUsuario';
import TemPermissao from "../../helpers/TemPermissao";
import * as roles from "../../store/roles";
import { TIPO_RELATORIO } from "../../store/tipoRelatorioCarimbo";
import { CARIMBO } from '../../store/tipoListaEnvioProduto';

class EnvioVerificaMontrealToi extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.defaultInitialState(),
            labelDataInicio: "Data do envio da rotina (Início):",
            labelDataFim: "Data do envio da rotina (Fim):",
            labelDataInicioCampanha: "Data do envio da rotina (Início):",
            labelDataFimCampanha: "Data do envio da rotina (Fim):",
            labelDataInicioEmailsValidados: "Data da validação dos e-mails (Início):",
            labelDataFimEmailsValidados: "Data da validação dos e-mails (Fim):",
            labelEmailOuTelefone: "Contato:",
            nomeMailing: "",

            form: this.formInitialState(),
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            comboEmpresa:
            {
                results: undefined
            },
            comboStatus:
            {
                results: undefined
            },
            comboTipoRelatorio:
            {
                results: undefined
            },
            comboMotivos:
            {
                results: undefined
            },
            comboCampos:
            {
                results: undefined
            },
            comboNomeCampanhas:
            {
                results: undefined
            },
            comboNomeCampanhasAutoComplete: [],
            campanhaValues: {
                value: "",
                label: ""
            },
            comboNomeMailings:
            {
                results: undefined
            },
            comboNomeMailingsAutoComplete: [],
            mailingValues: {
                value: "",
                label: ""
            }
        }

        this.handlePesquisarRelatorio = this.handlePesquisarRelatorio.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleChangeCombo = this.handleChangeCombo.bind(this);
        this.handleChangeComboCampos = this.handleChangeComboCampos.bind(this);
        this.handleLimparPesquisa = this.handleLimparPesquisa.bind(this);
        this.handleLimparRotina = this.handleLimparRotina.bind(this);
        this.handlePesquisarRelatorioEmail = this.handlePesquisarRelatorioEmail.bind(this);
        this.onNomeCampanhaChange = this.onNomeCampanhaChange.bind(this);
        this.onNomeMailingChange = this.onNomeMailingChange.bind(this);
        this.verificaData = this.verificaData.bind(this);
    }

    defaultInitialState() {
        let desabilitarCamposEnvioUnico = !(this.props.auth.user.papel.includes(roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO)) && 
        (this.props.auth.user.papel.includes(roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO));

        return {
            isGoing: true,
            novoAcesso: true,
            loading: false,
            pageInit: 0,
            isLoggedIn: true,
            tableAux: "",
            rotinaDisabled: false,
            mailingDisabled: desabilitarCamposEnvioUnico,
            nomeContatoDisabled: false,
            nomeEmailDisabled: false,
            nomeTelefoneDisabled: false,
            nomeDocumentoDisabled: false,
            contatoDisabled: false,
            motivoDisabled: false,
            dataInicioDisabled: false,
            dataFimDisabled: false,
            camposDisabled: true,
            campoDisabled: true,
            botaoDisabled: false,
            envioUnicoDisabled: true,
        }
    }

    formInitialState() {
        return {
            campanha: "",
            empresa: "",
            nomeContato: "",
            nomeEmail: "",
            nomeTelefone: "",
            nomeDocumento: "",
            status: "",
            email: "",
            motivo: "",
            dataInicio: "",
            dataFim: "",
            tipoRelatorio: "",
            tipoEnvio: 'Rastreado Verificar',
            campos: "",
            campo: "",
            idMailing: "",
            envioUnico: false,
            nomeRelatorioExcel: "",
        }
    }

    componentDidMount() {
        this.LoadComboEmpresa();
        this.LoadComboNomeCampanhas();
        this.LoadComboMotivos();
        this.LoadComboTipoRelatorio();
        this.LoadListaCampos();
        this.LoadComboMailings();

    }

    handleChange(e) {
        const form = this.state.form;
        this.state.isLoggedIn = false;
        if (e.target.name === "envioUnico") {
            let checked = e.target.checked;
            this.setState({
                ...this.state,
                form: {
                    ...form,
                    envioUnico: checked
                }
            });

        } else {
            this.setState({ form: { ...form, [e.target.name]: e.target.value } });
        }
    }

    onEmpresaNameChange = (event) => {
        const form = this.state.form;
        let mailingCombo = '';

        if (event.target.options[event.target.selectedIndex].text == "Selecione...") {
            this.LoadComboMailings();
        } else if (form.dataInicio != "" && form.dataFim != "") {
            this.LoadComboMailingsByEmpresaData(event.target.options[event.target.selectedIndex].text, form.dataInicio, form.dataFim);
        } else {
            this.LoadComboMailingsByEmpresa(event.target.options[event.target.selectedIndex].text);
        }
        this.setState({ form: { ...form, 'mailing': mailingCombo } });
        this.setState({ ...this.state, mailingValues: "" });
        this.state.isLoggedIn = false;
        this.setState({ form: { ...form, [event.target.name]: event.target.value } });
    }

    onNomeCampanhaChange = (event, values) => {
        const form = this.state.form;
        let campanhaCombo = '';

        if (values) {
            campanhaCombo = values.value;
        }

        this.setState({ form: { ...form, 'campanha': campanhaCombo } });
        this.setState({ ...this.state, campanhaValues: values });
    }

    onNomeMailingChange = (event, values) => {
        const form = this.state.form;
        let mailingCombo = '';

        if (values) {
            mailingCombo = values.value;
        }

        this.setState({ form: { ...form, 'mailing': mailingCombo } });
        this.setState({ ...this.state, mailingValues: values });

    }

    handleChangeComboCampos(e) {
        if (e.target.value != null) {
            this.setState({
                ...this.state,
                campoDisabled: false
            });
        }
    }

    handleChangeCombo(e) {
        this.state.isLoggedIn = false;
        this.state.form.tipoRelatorio = e.target.value;
        let desabilitarCamposEnvioUnico = !(this.props.auth.user.papel.includes(roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO));

        if (e.target.value == 12) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: false,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: false,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: desabilitarCamposEnvioUnico,
                campoDisabled: desabilitarCamposEnvioUnico,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 13) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: false,
                nomeDocumentoDisabled: false,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: desabilitarCamposEnvioUnico,
                campoDisabled: desabilitarCamposEnvioUnico,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 15) {
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: false,
                nomeTelefoneDisabled: false,
                nomeDocumentoDisabled: false,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: desabilitarCamposEnvioUnico,
                campoDisabled: desabilitarCamposEnvioUnico,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 1 || e.target.value == 26) {
            this.handleLimparRotina();
            this.handleLimparMailing();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: true,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 2 || e.target.value == 14
            || e.target.value == 16 || e.target.value == 17) {
            this.handleLimparRotina();
            this.handleLimparMailing();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 3 || e.target.value == 10) {
            this.handleLimparMailing();
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: true,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 18) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: true,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 19 || e.target.value == 21) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: true,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 20) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: true,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: true,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        }
        else if (e.target.value == 22) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: false,
                nomeContatoDisabled: true,
                nomeEmailDisabled: true,
                nomeTelefoneDisabled: false,
                nomeDocumentoDisabled: false,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: false,
                envioUnicoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 23) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: false,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: false,
                nomeTelefoneDisabled: false,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: false,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else if (e.target.value == 24) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: false,
                nomeTelefoneDisabled: false,
                nomeDocumentoDisabled: false,
                contatoDisabled: true,
                motivoDisabled: true,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        }else if (e.target.value == 25) {
            this.handleLimparRotina();
            this.setState({
                ...this.state,
                rotinaDisabled: true,
                mailingDisabled: desabilitarCamposEnvioUnico,
                nomeContatoDisabled: true,
                nomeEmailDisabled: false,
                nomeTelefoneDisabled: true,
                nomeDocumentoDisabled: true,
                contatoDisabled: true,
                motivoDisabled: true,
                dataInicioDisabled: false,
                dataFimDisabled: false,
                camposDisabled: true,
                campoDisabled: true,
                botaoDisabled: false,
                envioUnicoDisabled: false,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        } else {
            this.handleLimparMailing();
            this.setState({
                ...this.state,
                botaoDisabled: true,
                labelDataInicio: this.state.labelDataInicioCampanha,
                labelDataFim: this.state.labelDataFimCampanha
            });
        }
    }

    handlePesquisarRelatorio() {
        if (this.state.loading) {
            return;
        }

        this.setState({
            list: [],
            isLoggedIn: true,
            page: 1
        }, () => {
            this.handleRelatorio();
        });
    }

    handlePesquisarRelatorioEmail() {
        this.state.list = [];
        this.state.isLoggedIn = true;
        this.state.page = 1;
        this.handleRelatorioEmail();
    }

    handleLimparPesquisa() {
        if (this.state.loading) {
            return;
        }

        this.setState({
            ...this.defaultInitialState(),
            list: {
                currentPage: 0,
                pageCount: 0,
                pageSize: 0,
                rowCount: 0,
                results: undefined
            },
            form: this.formInitialState(),
            campanhaValues: { value: "", label: "" },
            mailingValues: { value: "", label: "" },
            loading: false
        });
    }

    handleLimparRotina() {
        this.state.form.campanha = "";
        this.state.campanhaValues = { value: "", label: "" }
    }

    handleLimparMailing() {
        this.state.form.mailing = "";
        this.state.mailingValues = { value: "", label: "" }
    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.handleRelatorio(pageNumber);
    }

    handleRelatorio(pageNumber) {
        this.LoadTable(pageNumber);
    }

    handleRelatorioEmail() {
        this.LoadTableEmail();
    }

    render() {
        const form = this.state.form;
        const campanhas = this.state.comboNomeCampanhasAutoComplete;
        const mailings = this.state.comboNomeMailingsAutoComplete;
        const isLoggedIn = this.state.isLoggedIn;
        let table;
        let mostrarEnvioUnico = this.props.auth.user.papel.includes(roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO) && 
            this.props.auth.user.papel.includes(roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO);

        if (isLoggedIn) {

           if (form.tipoRelatorio === "12") {
                table = <TableDetalheContatoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "1" || form.tipoRelatorio === "26" || form.tipoRelatorio === "19") {
                table = <TableEnvioLeituraToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "2" || form.tipoRelatorio === "14" || form.tipoRelatorio === "20") {
                table = <TableNaoRecebidosToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "3" || form.tipoRelatorio === "10" || form.tipoRelatorio === "21") {
                table = <TableVolumetriaToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "13") {
                table = <TableDetalheContatoSmsToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "15") {
                table = <TableDetalheContatoUnificadoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "16" || form.tipoRelatorio === "17") {
                table = <TableFaturamentoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "18") {
                table = <TableContabilizacaoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "22") {
                table = <TableDetalheContatoWhatsappToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "23") {
                table = <TableDetalheAgendamentoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "24") {
                table = <TableDetalhadoSimplificadoToi data={this.state.list} history={this.props.history} />;
            } else if (form.tipoRelatorio === "25") {
                table = <TableVolumetriaUsuario data={this.state.list} history={this.props.history} />;
            }

            this.state.tableAux = table;
        } else {
            table = this.state.tableAux;
        }

        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Buscar relatório Carimbo do Tempo</h3>
                            </Title>

                            <Content>

                                <Row className="form-row">
                                    <div className="form-group col-md-6">
                                        <label>Rotina:</label>
                                        <Autocomplete
                                            id="combo-campanha"
                                            options={campanhas}
                                            getOptionLabel={(option) => option.label}
                                            style={{ marginTop: -8 }}
                                            onChange={this.onNomeCampanhaChange}
                                            disabled={this.state.rotinaDisabled}
                                            value={this.state.campanhaValues}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) =>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        margin="dense"
                                                    />
                                            }
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <label>Empresa:</label>
                                        <Select name="empresa" selected={form.empresa} data={this.state.comboEmpresa} onChange={this.onEmpresaNameChange} placeholder="Empresa" />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Email:</label>
                                        <input type="text" name="nomeEmail" value={form.nomeEmail} onChange={this.handleChange} className="form-control" disabled={this.state.nomeEmailDisabled} />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Telefone:</label>
                                        <input type="text" name="nomeTelefone" value={form.nomeTelefone} onChange={this.handleChange} className="form-control" disabled={this.state.nomeTelefoneDisabled} />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Documento:</label>
                                        <input type="text" name="nomeDocumento" value={form.nomeDocumento} onChange={this.handleChange} className="form-control" disabled={this.state.nomeDocumentoDisabled} />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>{this.state.labelDataInicio}</label>
                                        <InputMask mask="99/99/9999" name="dataInicio" value={form.dataInicio} placeholder="___/___/___" onChange={this.handleChange} className="form-control" disabled={this.state.dataInicioDisabled} />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>{this.state.labelDataFim}</label>
                                        <InputMask mask="99/99/9999" name="dataFim" value={form.dataFim} placeholder="___/___/___" onChange={this.handleChange} className="form-control" disabled={this.state.dataFimDisabled} />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Motivo:</label>
                                        <Select name="motivo" selected={form.motivo} data={this.state.comboMotivos} onChange={this.handleChange} placeholder="Motivo" disabled={this.state.motivoDisabled} />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-4">
                                        <label>Por Campos:</label>
                                        <Select name="campos" selected={form.campos} data={this.state.comboCampos} onChange={this.handleChange} disabled={this.state.camposDisabled} placeholder="Por Campos" />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Campo:</label>
                                        <input type="text" name="campo" value={form.campo} onChange={this.handleChange} className="form-control" disabled={this.state.campoDisabled} />
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label>Mailing:</label>
                                        <Autocomplete
                                            id="combo-mailing"
                                            options={mailings}
                                            getOptionLabel={(option) => option.label}
                                            style={{ marginTop: -8 }}
                                            onChange={this.onNomeMailingChange}
                                            disabled={this.state.mailingDisabled}
                                            value={this.state.mailingValues}
                                            getOptionSelected={(option) => option.value}
                                            renderInput={
                                                (params) =>
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        margin="dense"
                                                    />
                                            }
                                        />
                                    </div>
                                </Row>

                                <Row className="form-row">
                                    <div className="form-group col-md-3">
                                        <label>Filtros:</label>
                                        <Select name="tipoRelatorio" selected={form.tipoRelatorio} data={this.state.comboTipoRelatorio} onChange={this.handleChangeCombo} placeholder="Tipo Relatório" />
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28px', marginLeft: "5px" }}>
                                        <Button onClick={this.handlePesquisarRelatorio}><Icon name="far fa-search" /> Pesquisar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28px', marginLeft: "40px" }}>
                                        <Button onClick={this.handlePesquisarRelatorioEmail} disabled={this.state.botaoDisabled}><Icon name="far fa-search" />Relatório agendado</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28px', marginLeft: "102px" }}>
                                        <Button onClick={this.handleLimparPesquisa} ><Icon name="far fa-trash" /> Limpar</Button>
                                    </div>
                                    <div className="form-group col-md-1" style={{ marginTop: '28px', marginLeft: "20px" }}>
                                        <TableToExcel className="btn btn-primary px-3 fs-14" table="table-to-export" buttonText="Gerar Excel" disabled={this.state.form.nomeRelatorioExcel === ""} filename={this.state.form.nomeRelatorioExcel} />
                                    </div>
                                </Row>

                                <TemPermissao permissaoBoolean={mostrarEnvioUnico}>
                                    <Column size="3" className="px-1">
                                        <input placeholder='envio unico'
                                            type='checkbox'
                                            className='form-check-input'
                                            disabled={this.state.envioUnicoDisabled}
                                            name="envioUnico"
                                            onChange={this.handleChange} checked={form.envioUnico}
                                            style={{marginTop: '-10px', marginLeft: 0 }}
                                        />
                                        <label for="envioUnico" className='form-check-label' style={{position: 'relative', top: '-14px', marginLeft: "1.25rem" }}>Envio único?</label>
                                    </Column>
                                </TemPermissao>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        {table}

                                    </Column>
                                </Row>

                            </Content>

                        </IBox>
                    </Column>
                </Row>


                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>

            </div>
        );
    }

    LoadListaCampos() {
        let self = this;

        const url = `${c.API_BASE_URL}/toi-campos`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboCampos: response });
        });

    }

    LoadComboNomeCampanhas() {
        let self = this;

        const url = `${c.API_BASE_URL}/toi-campanhas`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeCampanhas: response });
            self.setState({ ...self.state, loading: false, comboNomeCampanhasAutoComplete: response.results });
        });
    }

    LoadComboMailings() {
        let self = this;

        const url = `${c.API_BASE_URL}/mailing-list`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeMailings: response });
            self.setState({ ...self.state, loading: false, comboNomeMailingsAutoComplete: response });
        });
    }

    LoadComboMailingsByEmpresa(empresa) {
        let self = this;
        const url = `${c.API_BASE_URL}/mailing-list/` + empresa;

        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeMailings: response });
            self.setState({ ...self.state, loading: false, comboNomeMailingsAutoComplete: response });
        });
    }

    LoadComboMailingsByEmpresaData(empresa, dataIni, dataFim) {
        let self = this;
        let dataInicial = dataIni.split('/').reverse().join('-');
        let dataFinal = dataFim.split('/').reverse().join('-');

        const url = `${c.API_BASE_URL}/mailing-list/` + empresa + '/' + dataInicial + '/' + dataFinal;

        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboNomeMailings: response });
            self.setState({ ...self.state, loading: false, comboNomeMailingsAutoComplete: response });
        });
    }

    LoadComboEmpresa() {
        let self = this;
        const data = JSON.stringify({
            'nome_produto': CARIMBO
        });
        const url = `${c.API_BASE_URL}/company-user`;
        const options =
        {
            method: 'POST'
            , headers: { 'Content-Type': 'application/json' }
            , body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    LoadComboMotivos() {
        let self = this;

        const url = `${c.API_BASE_URL}/toi-motivos`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboMotivos: response });
        });
    }

    LoadComboTipoRelatorio() {
        let self = this;

        const url = `${c.API_BASE_URL}/toi-relatorios`;
        const options =
        {
            method: 'GET'
            , headers: { 'Content-Type': 'application/json' }
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboTipoRelatorio: response });
        });
    }

    LoadTable(pageNumber) {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;

        let relatorioNaoImplementado = 999;
        let tipoRelatorio = this.state.form.tipoRelatorio === "" || this.state.form.tipoRelatorio === "Selecione..." ? relatorioNaoImplementado : this.state.form.tipoRelatorio;
        this.state.form.tipoRelatorio = tipoRelatorio;
        this.state.form.nomeRelatorioExcel = TIPO_RELATORIO(this.state.form.tipoRelatorio);

        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let campos = this.state.form.campos === "Selecione..." ? "" : this.state.form.campos;
        let mailing = this.state.mailingValues === null ? null : this.state.mailingValues.value;
        let envioUnicoSempreHabilitado = this.props.auth.user.papel.includes(roles.ROLE_ENVIO_UNICO_CARIMBO_TEMPO) 
                                            && !this.props.auth.user.papel.includes(roles.ROLE_ENVIO_MASSA_CARIMBO_TEMPO);

        let url = '';

        if (tipoRelatorio === "16" || tipoRelatorio === "17") {
            url = `${c.API_BASE_URL}/relatorio-faturamento-toi`
        } else {
            url = `${c.API_BASE_URL}/relatorio-toi`;
        }
        const options =
        {
            method: 'POST'
            , headers: { 'Content-Type': 'application/json' }
            , body: JSON.stringify({
                page: page,
                idCampanha: this.state.campanhaValues === null ? null : this.state.campanhaValues.value,
                idEmpresa: empresa,
                nomeContato: this.state.form.nomeContato,
                nomeEmail: this.state.form.nomeEmail,
                nomeTelefone: this.state.form.nomeTelefone,
                nomeDocumento: this.state.form.nomeDocumento,
                status: status,
                emailContato: this.state.form.email,
                motivo: motivo,
                dataEnvioInicio: this.state.form.dataInicio,
                dataEnvioFim: this.state.form.dataFim,
                tipoRelatorio: tipoRelatorio,
                tipoEnvio: 'Rastreado Verificar',
                idCampos: campos,
                campo: this.state.form.campo,
                idMailing: mailing,
                envioUnico: envioUnicoSempreHabilitado ? true : this.state.envioUnicoDisabled ? null : this.state.form.envioUnico
            })
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            let listResponse;
            if (self.state.loading || self.state.novoAcesso) {
                
                if (response.length === 0) {
                    listResponse = {...self.state.list};
                    listResponse.results = 0;
                } else {
                    listResponse = response;
                }
                self.setState({ ...self.state, loading: false, novoAcesso: false, list: listResponse });
            }
        });

    }

    tipoRelatorioNecessitaEmpresa(tipoRelatorio) {
        return (tipoRelatorio == 3 || tipoRelatorio == 5 || tipoRelatorio == 6 || tipoRelatorio == 7 || tipoRelatorio == 10);
    }

    tipoRelatorioNecessitaDataInicio(tipoRelatorio) {
        return (tipoRelatorio == 9 || tipoRelatorio === "10");
    }

    verificaData(inicio, fim) {
        const MILLISECOND = 1;
        const SECOND = MILLISECOND * 1000;
        const MINUTE = SECOND * 60;
        const HOUR = MINUTE * 60;
        const DAY = HOUR * 24;

        var inicioSplit = inicio.split("/");
        var fimSplit = fim.split("/");

        var dataInicial = new Date(inicioSplit[2], inicioSplit[1], inicioSplit[0]);
        var dataFim = new Date(fimSplit[2], fimSplit[1], fimSplit[0]);

        var milis = Math.abs(dataInicial.getTime() -
            dataFim.getTime());

        var meses = Math.floor(milis / DAY / 30);


        return meses;
    }

    LoadTableEmail() {
        let self = this;
        let page = 0;
        let relatorioNaoImplementado = 999;

        let tipoRelatorio = this.state.form.tipoRelatorio === "" || this.state.form.tipoRelatorio === "Selecione..." ? relatorioNaoImplementado : this.state.form.tipoRelatorio;

        let empresa = this.state.form.empresa === "Selecione..." ? "" : this.state.form.empresa;
        let status = this.state.form.status === "Selecione..." ? "" : this.state.form.status;
        let motivo = this.state.form.motivo === "Selecione..." ? "" : this.state.form.motivo;
        let campos = this.state.form.campos === "Selecione..." ? "" : this.state.form.campos;
        let idUsuario = self.props.auth.user.id;
        let nomeCampanha = this.state.campanhaValues === null ? "" : this.state.campanhaValues.label;

        if (isBlank(empresa)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar a Empresa");
            return;
        }
        if (isBlank(this.state.form.dataInicio)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro Data do envio da campanha (Início).");
            return
        }
        if (isBlank(this.state.form.dataFim)) {
            c.TOASTER_INFO("Para realizar essa pesquisa é necessário informar o filtro Data do envio da campanha (Fim).");
            return
        }
        if (this.verificaData(this.state.form.dataInicio, this.state.form.dataFim) > 6) {
            c.TOASTER_INFO("Data inicial da rotina e Data final da rotina não deve ultrapassar 6 meses");
        } else {

            const url = `${c.API_BASE_URL}/relatorio/email`;
            const options =
            {
                method: 'POST'
                , headers: { 'Content-Type': 'application/json' }
                , body: JSON.stringify({
                    page: page,
                    idCampanha: this.state.campanhaValues === null ? null : this.state.campanhaValues.value,
                    nomeCampanha: nomeCampanha,
                    nomeContato: this.state.form.nomeContato,
                    nomeEmail: this.state.form.nomeEmail,
                    nomeTelefone: this.state.form.nomeTelefone,
                    nomeDocumento: this.state.form.nomeDocumento,
                    emailContato: this.state.form.email,
                    idEmpresa: empresa,
                    idMailing: this.state.mailingValues === null ? null : this.state.mailingValues.value,
                    status: status,
                    filtroIdMotivo: motivo,
                    tipoRelatorio: tipoRelatorio,
                    idCampos: campos,
                    campo: this.state.form.campo,
                    tipoEnvio: 'Rastreado Verificar',
                    idUsuario: idUsuario,
                    dataEnvioInicio: this.state.form.dataInicio,
                    dataEnvioFim: this.state.form.dataFim,
                    envioUnico: this.state.envioUnicoDisabled ? null : this.state.form.envioUnico

                })
            };

            callApi(url, options, function (response) {
                if (response.status === 'OK') {
                    c.TOASTER_SUCCESS(response.message);
                } else {
                    c.TOASTER_ERROR(response.message);
                }
            });

        }
    }

}


function mapStateToProps(state) {
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch) {
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EnvioVerificaMontrealToi));
